import { render, staticRenderFns } from "./longTextView.vue?vue&type=template&id=787f7970&scoped=true"
import script from "./longTextView.vue?vue&type=script&lang=js"
export * from "./longTextView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f7970",
  null
  
)

export default component.exports